var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"tm-visual-scenes",class:{ selected: _vm.isSelected, hovered: _vm.isHovered }},_vm._l((_vm.relevantScenes),function(scene){return _c('div',{key:scene.guid,staticClass:"scene",style:(_vm.getSceneStyle(scene))})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }